export type Summary = {
  customerCount: number
  runningProjectCount: number
  blockedCustomerCount: number
}

export type Activity = {
  customerOrderCount: number
  customerProductionCount: number
  projectProductionCount: number
}

export type CustomerItem = {
  id: number
  debtorId: string
  name: string
  blocked: boolean
  projectCount: number
  orderCount: number
  productionAmount: number
  invoicing: CustomerInvoicing
}
export type CustomerInvoicing = {
  invoicedTotalPrice: number
  outstandingTotalPrice: number
  overdueTotalPrice: number
}

export const CustomerDashboardDeviationType = {
  blocked: 0,
  outstandingInvoices: 1,
  overdueInvoices: 2
} as const

export type Deviation = {
  type: number
  severity: number
  count: number
}

export type CustomersDashboardData = {
  summary: Summary
  deviations: Deviation[]
  list: CustomerItem[]
}
